import API_CLIENT from "../../utils/Api";

export async function GetAIRecommendations(prompt) {
  return await API_CLIENT.get(`/bundles/ai-search?query=${prompt}`);
}
export async function GenerateText(prompt) {
  return API_CLIENT.post(`/bundles/handle-prompt`, {
    prompt,
  });
}
